import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/ambassador-sales")({
  component: lazyRouteComponent(() => import("./-pages/admin.ambassador-sales")),
  head: () => ({
    meta: [
      { title: "مبيعات السفراء · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
